import { createFileRoute } from "@tanstack/react-router";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AppointmentTypeRoomTypesForm } from "@/components/appointment/type/appointment-type-room-types-form";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const GetAppointmentTypeRoomTypesQuery = graphql(`
  query GetAppointmentTypeRoomTypesQuery {
    ...AppointmentTypeRoomTypesQueryFragment
  }
`);

const CreateAppointmentTypeRoomTypesPage = (): JSX.Element => {
  const queryResult = useGraphQL(GetAppointmentTypeRoomTypesQuery);
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Tipo de sala" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <AppointmentTypeRoomTypesForm data={data} appointmentTypeId={null} />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/create/room-type",
)({
  component: CreateAppointmentTypeRoomTypesPage,
});
